export default "__VITE_ASSET__9a382d44__"